import { render, staticRenderFns } from "./LoginByCode.vue?vue&type=template&id=6ef20a18&scoped=true"
import script from "./LoginByCode.vue?vue&type=script&lang=js"
export * from "./LoginByCode.vue?vue&type=script&lang=js"
import style0 from "./LoginByCode.vue?vue&type=style&index=0&id=6ef20a18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef20a18",
  null
  
)

export default component.exports